import { gql } from '@apollo/client'
import report from './report.fragment'

export const GET_REPORTS_IN_DOWNLOADS_VIEW_BY_COUNTRY_TYPE = gql`
  query FindReportsInDownloadsViewByCountryType(
    $countries: [Country!]!
    $reportType: ReportType!
    $pagination: CursorPaginationReportInput!
  ) {
    findReportsInDownloadsViewByCountryAndType(countries: $countries, reportType: $reportType, pagination: $pagination) {
      edges {
        ...Report
      }
      endCursorReportId
      endCursorReportDate
      hasNextPage
    }
  }
  ${report}
`

export const GET_TARGET_REPORTS_BY_COUNTRY_AND_COMPANY = gql`
  query FindTargetReportsByCountryAndCompany($country: Country!, $companyId: HashedId!) {
    findTargetReportsByCountryAndCompany(country: $country, companyId: $companyId) {
      ...Report
    }
  }
  ${report}
`

export const YEARS_AND_COMPANIES_FOR_RANKING_REPORT = gql`
  query FindPossibleYearsAndCompaniesForRankingReport($country: Country) {
    findPossibleYearsAndCompaniesForRankingReport(country: $country) {
      possibleYears
      possibleCompanies {
        companyId
        companyName
      }
    }
  }
`

export const RANKING_REPORT_BY_COUNTRY_AND_FILTERS = gql`
  query GetRankingReportsByCountryAndFilters(
    $countries: [Country!]!
    $filters: RankingReportFilterInput!
    $pagination: CursorPaginationReportInput!
  ) {
    getRankingReportsByCountryAndFilters(countries: $countries, filters: $filters, pagination: $pagination) {
      edges {
        ...Report
      }
      endCursorReportId
      endCursorReportDate
      hasNextPage
    }
  }
  ${report}
`
